import React from "react";
import PageTitle from "../../components/shared/PageTitle";
import {
  CalendarDaysIcon,
  MapPinIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function RaceDay() {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.locale.locale);

  const data = t("raceday", { returnObjects: true });
  const items = Array.isArray(data) ? data : [];

  return (
    <div className="text-white px-4">
      <div className="relative">
        <PageTitle title={locale === "en" ? "Race Day" : "Hari Lomba"} />
      </div>

      <div className="pt-80 pb-10 bg-black">
        <div className="bg-black container mx-auto w-full font-ttFirsNeue text-white">
          <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="space-y-4 inline-flex space-x-3 place-self-center">
              <CalendarDaysIcon width={24} />
              <div>
                <h1 className="text-xl font-bold uppercase">
                  {items[0]?.title}
                </h1>
                <div
                  dangerouslySetInnerHTML={{ __html: items[0]?.content ?? "" }}
                  className="font-light"
                />
              </div>
            </div>

            <div className="space-y-4 inline-flex space-x-3 place-self-center">
              <MapPinIcon width={24} />
              <div>
                <h1 className="text-xl font-bold uppercase">
                  {items[1]?.title}
                </h1>
                <p className="font-light">{items[1]?.content}</p>
              </div>
            </div>

            <div className="space-y-4 inline-flex space-x-3 place-self-center">
              <UsersIcon width={24} />
              <div>
                <h1 className="text-xl font-bold uppercase">
                  {items[2]?.title}
                </h1>
                <p className="font-light">{items[2]?.content}</p>
              </div>
            </div>
          </div>

          <div className="mt-20">
            <iframe
              title="Lokasi"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.2293274328863!2d110.40993997618027!3d-6.982242468377256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e708ba87e15e37b%3A0xb6685e7f890af6d9!2sBalai%20Kota%20Semarang!5e0!3m2!1sen!2sid!4v1730135247845!5m2!1sen!2sid"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="invert w-full h-[40rem] rounded-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
